// Global/Progressbar.jsx
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { useEffect } from "react";

const PROGRESS_CONFIG = {
  showSpinner: false,
  minimum: 0.08,
  trickleSpeed: 120,
};

let activeRequests = 0;
let configured = false;

function configureProgressBar() {
  if (configured) return;
  NProgress.configure(PROGRESS_CONFIG);
  configured = true;
}

export const startProgress = () => {
  configureProgressBar();
  activeRequests += 1;

  if (activeRequests === 1) {
    NProgress.start();
    NProgress.set(PROGRESS_CONFIG.minimum);
    return;
  }

  NProgress.inc(0.04);
};

export const doneProgress = () => {
  configureProgressBar();
  if (activeRequests > 0) {
    activeRequests -= 1;
  }

  if (activeRequests === 0) {
    NProgress.done();
  }
};

const NPROGRESS_STYLES = `
  #nprogress .bar {
    height: 4px;
  }
  #nprogress .peg {
    box-shadow: 0 0 10px #16a34a, 0 0 5px #16a34a;
    height: 100%;
  }
`;

export default function ProgressBar() {
  useEffect(() => {
    configureProgressBar();
  }, []);

  return <style>{NPROGRESS_STYLES}</style>;
}
